/**
 * ls-calculate-yard-size.js
 * Terra Draw replacement for deprecated google.maps.drawing.DrawingManager
 */

// ── Inject CSS to shrink the Google InfoWindow and Style Toolbar ──────
const style = document.createElement('style');
style.innerHTML = `
  .gm-style .gm-style-iw-c { padding: 10px !important; max-width: 130px !important; min-width: 0 !important; }
  .gm-style .gm-style-iw-d { overflow: hidden !important; }
  .gm-style .gm-style-iw-tc::after { display: none !important; }
  .ls-iw-compact { font-family: sans-serif; font-size: 13px; font-weight: 300; display: flex; align-items: center; gap: 4px; white-space: nowrap; pointer-events: none; }
  .ls-iw-compact button { pointer-events: auto; }

  /* New Toolbar Styles */
  .ls-td-toolbar-wrap {
    display: flex;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    border-radius: 2px;
    margin: 10px;
    overflow: hidden;
    border: 1px solid #ccc;
  }
  .ls-td-toolbar-btn {
    background: #fff;
    border: none;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: background 0.2s;
  }
  .ls-td-toolbar-btn:hover { background-color: #f1f1f1; }
  .ls-td-toolbar-btn svg { width: 18px; height: 18px; fill: #666; }
  .ls-td-toolbar-btn.active { background-color: #ebebeb; }
  .ls-td-toolbar-btn.active svg { fill: #000; }
  .ls-td-divider { width: 1px; background-color: #e6e6e6; height: 24px; align-self: center; }
`;
document.head.appendChild(style);

customElements.get('calculate-yard-size') || customElements.define(
    'calculate-yard-size',
    class extends HTMLElement {

        constructor() {
            super();
            this.map = null;
            this.draw = null;
            this.tdReady = false;
            this.polygons = [];
            this.infoWindows = [];
            this.totalArea = 0;
            this.gmPolygons = new Map();
            this.drawingPolylines = [];
            this.lat = Number(sessionStorage.getItem('ls-lat'));
            this.lng = Number(sessionStorage.getItem('ls-lng'));
            this.dialog = this.querySelector('.ls-modal__dialog');
            this.closeX = this.querySelector('.ls-modal__close-x');
        }

        connectedCallback() {
            this.initMap();
            this.initAddress();
            this.initHandleButtonClicks();
            this.handleAddressChangeClick();

            document.addEventListener('placeChanged', () => {
                window.location = '/pages/calculate-yard-size';
            }, false);

            this.handleCloseClick();
            this.handleBackdropClick();


        }

        initMap() {
            const { lat, lng } = this;
            if (!lat || !lng) return;
            const coordinates = { lat, lng };

            this.map = new google.maps.Map(this.querySelector('#property-map'), {
                zoom: 20,
                center: coordinates,
                gestureHandling: 'greedy',
                mapTypeId: 'satellite',
                fullscreenControl: true,
                rotateControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                tilt: 1,
                zoomControl: true,
                zoomControlOptions: { position: google.maps.ControlPosition.TOP_LEFT },
                backgroundColor: 'transparent'
            });

            new google.maps.Marker({
                position: coordinates,
                map: this.map,
                title: 'Entered Address',
                icon: { url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png' }
            });

            google.maps.event.addListenerOnce(this.map, 'tilesloaded', () => {
                this.initTerraDraw();
            });
        }

        initAddress() {
            const address = sessionStorage.getItem('ls-address');
            if (address || window.Shopify?.designMode) {
                const field = document.querySelector('.ls-calculate-yard-size #autocomplete');
                if (field) field.value = address || '';
                return;
            }
            window.location.href = '/';
        }

        initTerraDraw() {
            if (this.tdReady) return;
            const terraDraw = window.terraDraw;
            const terraDrawGoogleMapsAdapter = window.terraDrawGoogleMapsAdapter;
            if (!terraDraw || !terraDrawGoogleMapsAdapter) return;

            const { TerraDraw, TerraDrawPolygonMode, TerraDrawSelectMode } = terraDraw;
            const { TerraDrawGoogleMapsAdapter } = terraDrawGoogleMapsAdapter;
            this.tdReady = true;

            const adapter = new TerraDrawGoogleMapsAdapter({
                lib: google.maps,
                map: this.map,
                coordinatePrecision: 9
            });

            const pointerDistance = ("ontouchstart" in window || navigator.maxTouchPoints > 0) ? 7 : 2;

            this.draw = new TerraDraw({
                adapter,
                modes: [
                    new TerraDrawPolygonMode({
                        allowSelfIntersections: true,
                        pointerDistance,
                        styles: {
                            fillColor: '#FFE512',
                            fillOpacity: 0,
                            outlineColor: 'transparent',
                            outlineWidth: 0,
                            closingPointColor: '#FFE512',
                            closingPointWidth: 4,
                            closingPointOutlineColor: '#ffffff',
                            closingPointOutlineWidth: 1,
                        }
                    })
                ]
            });

            this.draw.start();
            this.draw.on('ready', () => {
                this.draw.setMode('polygon');
                this.injectToolbar();
            });
            this.draw.on('change', (ids, type) => this.onFeatureChange(ids, type));
            this.draw.on('finish', (featureId) => this.onPolygonFinished(featureId));
        }

        injectToolbar() {
            if (document.getElementById('ls-td-toolbar')) return;

            if (!document.getElementById('ls-tb-style')) {
                const s = document.createElement('style');
                s.id = 'ls-tb-style';
                s.textContent = `
                  .ls-toolbar {
                    display:flex;align-items:stretch;background:#fff;
                    border-radius:8px;box-shadow:0 2px 10px rgba(0,0,0,.35);
                    font-family:Roboto,Arial,sans-serif;margin:10px 0;overflow:hidden;
                  }
                  .ls-tb-btn {
                    display:flex;flex-direction:column;align-items:center;
                    justify-content:center;gap:4px;min-width:64px;
                    padding:10px 12px 8px;border:none;
                    border-right:1px solid #e8eaed;border-bottom:3px solid transparent;
                    background:transparent;cursor:pointer;font-size:11px;
                    font-weight:500;color:#5f6368;white-space:nowrap;
                    transition:background .12s,color .12s;line-height:1.2;
                  }
                  .ls-tb-btn:last-child{border-right:none}
                  .ls-tb-btn:hover{background:#f1f3f4;color:#202124}
                  .ls-tb-btn.is-active{background:#e8f0fe;color:#1967d2;border-bottom-color:#1967d2}
                `;
                document.head.appendChild(s);
            }

            const wrap = document.createElement('div');
            wrap.id = 'ls-td-toolbar';
            wrap.className = 'ls-toolbar';

            // Select
            const selBtn = document.createElement('button');
            selBtn.type = 'button';
            selBtn.className = 'ls-tb-btn';
            selBtn.title = "Select a shape to move or edit vertices";
            selBtn.innerHTML = `
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M5 3l5.5 14 2-6.5L19 8.5Z" fill="currentColor"/>
                <line x1="14.5" y1="14.5" x2="21" y2="21" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
              </svg><span>Select</span>`;

            // Polygon
            const drawBtn = document.createElement('button');
            drawBtn.type = 'button';
            drawBtn.className = 'ls-tb-btn is-active';
            drawBtn.title = "Click to place points — click the first point to close";
            drawBtn.innerHTML = `
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <polygon points="12,3 22,18 2,18" stroke="currentColor" stroke-width="2" fill="currentColor" fill-opacity=".2"/>
                <circle cx="12" cy="3"  r="2.5" fill="currentColor"/>
                <circle cx="22" cy="18" r="2.5" fill="currentColor"/>
                <circle cx="2"  cy="18" r="2.5" fill="currentColor"/>
              </svg><span>Polygon</span>`;

            const setActive = (mode) => {
                if (mode === 'polygon') {
                    drawBtn.classList.add('is-active');
                    selBtn.classList.remove('is-active');
                } else {
                    selBtn.classList.add('is-active');
                    drawBtn.classList.remove('is-active');
                }
            };

            selBtn.addEventListener('click', () => { this._enableEditing(); setActive('select'); });
            drawBtn.addEventListener('click', () => { this._disableEditing(); setActive('polygon'); });

            wrap.appendChild(selBtn);
            wrap.appendChild(drawBtn);

            this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(wrap);
        }

        onFeatureChange(ids, type) {
            if (type === 'delete') {
                ids.forEach((id) => this.removePolygon(id, false));
                this.updateYardAreas();
                return;
            }
            const snapshot = this.draw.getSnapshot();
            ids.forEach((featureId) => {
                const feat = snapshot.find((f) => f.id === featureId);
                if (!feat || feat.geometry.type !== 'Polygon') return;
                const ring = feat.geometry.coordinates[0];
                if (!ring || ring.length < 4) return;

                const area = this.calculateSqFt(ring);
                const center = this.computeCenter(ring);
                const existing = this.polygons.find((p) => p.featureId === featureId);

                if (existing) {
                    existing.area = area;
                    existing.center = center;
                    this.updateInfoWindow(featureId, area, center);
                    // Update the specific gmPolygon entry in-place (no full rebuild)
                    this._updateGmPolygon(featureId, ring);
                }

                // During drawing: render manual polylines for drawn edges only (no closing line)
                if (!this.polygons.find((p) => p.featureId === featureId)) {
                    this._renderDrawingEdges(ring);
                }
            });
            this.updateYardAreas();
        }

        onPolygonFinished(featureId) {
            this._clearDrawingEdges();

            const snapshot = this.draw.getSnapshot();
            const feat = snapshot.find((f) => f.id === featureId);
            if (!feat || feat.geometry.type !== 'Polygon') return;
            const ring = feat.geometry.coordinates[0];
            if (!ring || ring.length < 4) return;

            const area = this.calculateSqFt(ring);
            const center = this.computeCenter(ring);
            const existing = this.polygons.find((p) => p.featureId === featureId);

            if (!existing) {
                this.polygons.push({ featureId, area, center, ring });
                this.displayInfoWindow(featureId, area, center);
                this._createGmPolygonOverlay(featureId, ring);
            }
            this.updateYardAreas();
        }

        _createGmPolygonOverlay(featureId, ring) {
            const polygon = new google.maps.Polygon({
                paths: ring.map(c => ({ lat: c[1], lng: c[0] })),
                fillColor: '#FFE512',
                fillOpacity: 0.3,
                strokeColor: '#FFE512',
                strokeOpacity: 1,
                strokeWeight: 2,
                map: this.map,
                clickable: false
            });

            const dots = [];
            for (let i = 0; i < ring.length - 1; i++) {
                dots.push(this._createDot(ring[i][1], ring[i][0]));
                const midLat = (ring[i][1] + ring[i + 1][1]) / 2;
                const midLng = (ring[i][0] + ring[i + 1][0]) / 2;
                dots.push(this._createDot(midLat, midLng, 8, 'rgba(255,229,18,0.6)', '#ccc'));
            }

            this.gmPolygons.set(featureId, { polygon, dots });
        }

        _enableEditing() {
            // Stop Terra Draw completely so it doesn't intercept clicks
            this.draw.stop();
            this.gmPolygons.forEach((entry, featureId) => {
                // Hide our custom dots — Google Maps will show native handles
                entry.dots.forEach((d) => d.setMap(null));
                // Make polygon editable + draggable
                entry.polygon.setOptions({ editable: true, draggable: true, clickable: true });
                // Listen for vertex/midpoint edits
                const path = entry.polygon.getPath();
                const onEdit = () => this._onGmPathEdit(featureId);
                entry.listeners = [
                    google.maps.event.addListener(path, 'set_at', onEdit),
                    google.maps.event.addListener(path, 'insert_at', onEdit),
                    google.maps.event.addListener(path, 'remove_at', onEdit),
                    google.maps.event.addListener(entry.polygon, 'dragend', onEdit)
                ];
            });
        }

        _disableEditing() {
            this.gmPolygons.forEach((entry, featureId) => {
                // Remove edit listeners
                if (entry.listeners) {
                    entry.listeners.forEach((l) => google.maps.event.removeListener(l));
                    entry.listeners = null;
                }
                // Disable editing
                entry.polygon.setOptions({ editable: false, draggable: false, clickable: false });
                // Rebuild our custom dots from current polygon path
                const path = entry.polygon.getPath();
                const ring = [];
                path.forEach((p) => ring.push([p.lng(), p.lat()]));
                ring.push(ring[0]);
                const newDots = [];
                for (let i = 0; i < ring.length - 1; i++) {
                    newDots.push(this._createDot(ring[i][1], ring[i][0]));
                    const midLat = (ring[i][1] + ring[i + 1][1]) / 2;
                    const midLng = (ring[i][0] + ring[i + 1][0]) / 2;
                    newDots.push(this._createDot(midLat, midLng, 8, 'rgba(255,229,18,0.6)', '#ccc'));
                }
                entry.dots = newDots;
            });
            // Restart Terra Draw and go back to polygon drawing mode
            this.draw.start();
            this.draw.setMode('polygon');
        }

        _onGmPathEdit(featureId) {
            const entry = this.gmPolygons.get(featureId);
            if (!entry) return;
            const path = entry.polygon.getPath();
            const ring = [];
            path.forEach((p) => ring.push([p.lng(), p.lat()]));
            ring.push(ring[0]);
            const area = this.calculateSqFt(ring);
            const center = this.computeCenter(ring);
            const existing = this.polygons.find((p) => p.featureId === featureId);
            if (existing) {
                existing.area = area;
                existing.center = center;
                existing.ring = ring;
                this.updateInfoWindow(featureId, area, center);
            }
            this.updateYardAreas();
        }

        _updateGmPolygon(featureId, ring) {
            const entry = this.gmPolygons.get(featureId);
            if (!entry) return;

            // Update polygon path
            entry.polygon.setPaths(ring.map(c => ({ lat: c[1], lng: c[0] })));

            // Rebuild dots for this polygon only
            entry.dots.forEach((d) => d.setMap(null));
            const newDots = [];
            for (let i = 0; i < ring.length - 1; i++) {
                newDots.push(this._createDot(ring[i][1], ring[i][0]));
                const midLat = (ring[i][1] + ring[i + 1][1]) / 2;
                const midLng = (ring[i][0] + ring[i + 1][0]) / 2;
                newDots.push(this._createDot(midLat, midLng, 8, 'rgba(255,229,18,0.6)', '#ccc'));
            }
            entry.dots = newDots;
        }

        // Creates a dot overlay in the floatPane (topmost Google Maps layer)
        // This guarantees visibility above Terra Draw's canvas
        _createDot(lat, lng, size, bg, border) {
            const s = size || 10;
            const b = bg || '#FFE512';
            const br = border || '#fff';
            const overlay = new google.maps.OverlayView();
            overlay.position = new google.maps.LatLng(lat, lng);
            overlay.onAdd = function () {
                this.div = document.createElement('div');
                this.div.style.cssText = `position:absolute;width:${s}px;height:${s}px;border-radius:50%;background:${b};border:1.5px solid ${br};pointer-events:none;transform:translate(-50%,-50%);`;
                this.getPanes().markerLayer.appendChild(this.div);
            };
            overlay.draw = function () {
                const pos = this.getProjection().fromLatLngToDivPixel(this.position);
                if (this.div) {
                    this.div.style.left = pos.x + 'px';
                    this.div.style.top = pos.y + 'px';
                }
            };
            overlay.onRemove = function () {
                if (this.div) { this.div.parentNode.removeChild(this.div); this.div = null; }
            };
            overlay.setMap(this.map);
            return overlay;
        }

        _renderDrawingEdges(ring) {
            this._clearDrawingEdges();
            // Draw polylines for each edge EXCEPT the closing segment (last coord → first coord)
            // ring = [p1, p2, ..., pN, p1] — skip the last segment (pN → p1)
            for (let i = 0; i < ring.length - 2; i++) {
                const line = new google.maps.Polyline({
                    path: [
                        { lat: ring[i][1], lng: ring[i][0] },
                        { lat: ring[i + 1][1], lng: ring[i + 1][0] }
                    ],
                    strokeColor: '#FFE512',
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    map: this.map,
                    clickable: false
                });
                this.drawingPolylines.push(line);
            }

            // Add vertex dots + midpoints at each clicked point
            for (let i = 0; i < ring.length - 1; i++) {
                this.drawingPolylines.push(this._createDot(ring[i][1], ring[i][0]));
                // Midpoint on each drawn edge
                if (i < ring.length - 2) {
                    const midLat = (ring[i][1] + ring[i + 1][1]) / 2;
                    const midLng = (ring[i][0] + ring[i + 1][0]) / 2;
                    this.drawingPolylines.push(this._createDot(midLat, midLng, 8, 'rgba(255,229,18,0.6)', '#ccc'));
                }
            }
        }

        _clearDrawingEdges() {
            this.drawingPolylines.forEach((line) => line.setMap(null));
            this.drawingPolylines = [];
        }

        calculateSqFt(ring) {
            if (!window.google || !google.maps.geometry) return 0;
            const path = ring.map(coord => new google.maps.LatLng(coord[1], coord[0]));
            const sqMeters = google.maps.geometry.spherical.computeArea(path);
            return Math.round(sqMeters * 10.7639);
        }

        computeCenter(ring) {
            const pts = ring.slice(0, -1);
            return {
                lat: pts.reduce((s, p) => s + p[1], 0) / pts.length,
                lng: pts.reduce((s, p) => s + p[0], 0) / pts.length
            };
        }

        _iwContent(featureId, area) {
            return `
        <div class="ls-iw-compact" style="display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 500; color: #5f6368; padding: 2px 4px;">
          <span>${Intl.NumberFormat('en-US').format(area)} sqft</span>
          <button id="ls-del-${featureId}" type="button"  
            style="background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center;margin-left:auto;">
            <svg style="width:12px;height:12px;" viewBox="0 0 448 512"><path fill="#d00" d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"/></svg>
            </button>
        </div>`;
        }

        displayInfoWindow(featureId, area, center) {
            const iw = new google.maps.InfoWindow({
                content: this._iwContent(featureId, area),
                position: center,
                disableAutoPan: true,
                headerDisabled: true
            });
            iw.open({ map: this.map, shouldFocus: false });
            this.infoWindows.push({ featureId, iw });
            google.maps.event.addListener(iw, 'domready', () => this._bindDeleteBtn(featureId));
        }

        updateInfoWindow(featureId, area, center) {
            const entry = this.infoWindows.find((e) => e.featureId === featureId);
            if (!entry) return;
            entry.iw.setContent(this._iwContent(featureId, area));
            entry.iw.setPosition(center);
            google.maps.event.addListener(entry.iw, 'domready', () => this._bindDeleteBtn(featureId));
        }

        _bindDeleteBtn(featureId) {
            const btn = document.getElementById(`ls-del-${featureId}`);
            if (!btn) return;
            btn.onclick = (e) => {
                e.stopPropagation();
                this.removePolygon(featureId, true);
                this.updateYardAreas();
            };
        }

        removePolygon(featureId, alsoRemoveFromDraw = false) {
            if (alsoRemoveFromDraw && this.draw) {
                try {
                    this.draw.setMode('static');
                    this.draw.removeFeatures([featureId]);
                    this.draw.setMode('polygon');
                } catch (e) { console.error(e); }
            }
            const gmEntry = this.gmPolygons.get(featureId);
            if (gmEntry) {
                if (gmEntry.polygon) gmEntry.polygon.setMap(null);
                if (gmEntry.dots) gmEntry.dots.forEach((d) => d.setMap(null));
                this.gmPolygons.delete(featureId);
            }
            this._clearDrawingEdges();
            this.polygons = this.polygons.filter((p) => p.featureId !== featureId);
            const entry = this.infoWindows.find((e) => e.featureId === featureId);
            if (entry) {
                entry.iw.close();
                this.infoWindows = this.infoWindows.filter((e) => e.featureId !== featureId);
            }
        }

        updateYardAreas() {
            this.totalArea = this.polygons.reduce((a, c) => a + Number(c.area || 0), 0);
            sessionStorage.setItem('ls-yard-area', this.totalArea);
            this.addSquareFootageText(this.totalArea);
        }

        addSquareFootageText(value) {
            const field = this.querySelector('#calculate-yard-size__total-area');
            if (!field) return;
            field.value = value > 0 ? `${Intl.NumberFormat('en-US').format(value)} sq. ft.` : '0 sq. ft.';
        }

        initHandleButtonClicks() {
            this.querySelector('#calculate-yard-size__update-area').addEventListener('click', this.handleUpdateAreaButtonClick);
            this.querySelector('#calculate-yard-size__update-area-cancel').addEventListener('click', this.handleCancelAreaButtonClick);
            this.querySelector('#calculate-yard-size__update-area-save').addEventListener('click', this.handleSaveAreaButtonClick);
            this.querySelector('#calculate-yard-size__next-page').addEventListener('click', this.handleNextButtonClick);
        }

        handleUpdateAreaButtonClick = () => {
            if (this.draw) {
                this.draw.getSnapshot().forEach((f) => {
                    try { this.draw.removeFeatures([f.id]); } catch (_) { }
                });
            }
            this.infoWindows.forEach(({ iw }) => iw.close());
            this.infoWindows = []; this.polygons = []; this.totalArea = 0;
            this.gmPolygons.forEach((entry) => {
                if (entry.polygon) entry.polygon.setMap(null);
                if (entry.dots) entry.dots.forEach((d) => d.setMap(null));
            });
            this.gmPolygons.clear();
            this._clearDrawingEdges();
            sessionStorage.setItem('ls-yard-area', 0);
            const field = document.querySelector('#calculate-yard-size__total-area');
            if (field) { field.value = ''; field.removeAttribute('disabled'); field.focus(); }
            document.querySelector('#calculate-yard-size__update-area').classList.add('calculate-yard-size__update-area--hidden');
            document.querySelector('.calculate-yard-size__update-wrapper').classList.remove('calculate-yard-size__update-wrapper--hidden');
        };

        handleSaveAreaButtonClick = () => {
            const field = document.querySelector('#calculate-yard-size__total-area');
            const rawValue = field.value.replace(/[^0-9.]/g, '');
            this.totalArea = Number(rawValue) || 0;
            sessionStorage.setItem('ls-yard-area', this.totalArea);
            field.setAttribute('disabled', 'disabled');
            document.querySelector('#calculate-yard-size__update-area').classList.remove('calculate-yard-size__update-area--hidden');
            document.querySelector('.calculate-yard-size__update-wrapper').classList.add('calculate-yard-size__update-wrapper--hidden');
            this.addSquareFootageText(this.totalArea);
        };

        handleCancelAreaButtonClick = () => {
            if (this.draw) this.draw.setMode('polygon');
            document.querySelector('#calculate-yard-size__update-area').classList.remove('calculate-yard-size__update-area--hidden');
            document.querySelector('#calculate-yard-size__total-area').setAttribute('disabled', 'disabled');
            document.querySelector('.calculate-yard-size__update-wrapper').classList.add('calculate-yard-size__update-wrapper--hidden');
        };

        handleNextButtonClick = () => {
            const yardArea = Number(sessionStorage.getItem('ls-yard-area') || 0);
            if (yardArea > 80000) {
                this.dialog.querySelector('.ls-calculate-yard-size__warning').innerHTML = "<h3>Wow! Big yard.</h3><p>Contact us at <a href='tel:+19803171707'>980-317-1707</a></p>";
                this.handleOpen();
            } else if (yardArea > 0) {
                window.location.href = '/pages/choose-grass-type';
            } else {
                this.dialog.querySelector('.ls-calculate-yard-size__warning').innerHTML = "<h3>Yard size must be greater than zero.</h3><p>Use the tool to draw your lawn.</p>";
                this.handleOpen();
            }
        };

        handleAddressChangeClick = () => {
            const button = this.querySelector('#ls-calculate-yard-size__address-change-button');
            if (!button) return;
            button.addEventListener('click', () => {
                const field = this.querySelector('.ls-calculate-yard-size #autocomplete');
                field.removeAttribute('disabled'); field.value = ''; field.focus();
            });
        };

        handleOpen() { this.dialog.showModal(); }
        handleClose() { this.dialog.close(); }
        handleCloseClick() { if (this.closeX) this.closeX.addEventListener('click', () => this.handleClose()); }
        handleBackdropClick() {
            this.dialog?.addEventListener('click', (e) => {
                const r = this.dialog.getBoundingClientRect();
                if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) this.handleClose();
            });
        }
    }
);